import { render, staticRenderFns } from "./FolderMap.vue?vue&type=template&id=f2c61924"
import script from "./FolderMap.vue?vue&type=script&lang=js"
export * from "./FolderMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports